import * as React from 'react';
export const panelArrowRightSvg = React.forwardRef(
  function panelArrowRightSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M1.25 1a.75.75 0 0 0-.75.75v8.5a.75.75 0 0 0 1.5 0v-8.5A.75.75 0 0 0 1.25 1Zm5.22.22a.75.75 0 0 0 0 1.06l2.97 2.97H3.75a.75.75 0 0 0 0 1.5h5.69L6.47 9.72a.75.75 0 1 0 1.06 1.06l4.25-4.25a.747.747 0 0 0 0-1.06L7.53 1.22a.75.75 0 0 0-1.06 0Z',
      }),
    );
  },
);
panelArrowRightSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var panelArrowRight = {
  category: 'icon',
  colorable: true,
  name: 'panelArrowRight',
  svg: panelArrowRightSvg,
};
